import React from "react";
import useThemeColor from "../../../hooks/useThemeColor";
import useDarkMode from "../../../hooks/useDarkMode";
import "./neoToggle.css";

const NeoToggle = ({
  isChecked,
  onToggle,
  label,
  name,
  disabled = false,
  className = "",
}) => {
  const themeColor = useThemeColor();
  const isDarkMode = useDarkMode();

  const handleToggle = () => {
    if (disabled) return;
    onToggle(!isChecked);
  };

  return (
    <div className={`neo-toggle-wrap ${className}`}>
      <button
        type="button"
        className={`neo-toggle ${isChecked ? "is-checked" : ""} ${
          disabled ? "is-disabled" : ""
        }`}
        onClick={handleToggle}
        aria-pressed={isChecked}
        aria-label={label || name || "toggle"}
        disabled={disabled}
        style={{
          "--neo-theme-color": themeColor,
        }}
      >
        <span className="neo-toggle__box">
          <svg
            className="neo-toggle__check"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 5.5L7.5 14.5L3.5 10.5"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      {label && (
        <span
          className="neo-toggle__label"
          style={{ color: isDarkMode ? "#e9ecef" : "#1f2937" }}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default NeoToggle;
